var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 60,
    viewBox: "0 0 191 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_332_17201)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 30.0974,
    r: 24,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8684 33.558C25.9218 33.5002 25.9863 33.4538 26.058 33.4215C26.1297 33.3892 26.2073 33.3718 26.2859 33.3701H39.404C39.4595 33.3709 39.5136 33.3877 39.5598 33.4185C39.6059 33.4493 39.6423 33.4928 39.6643 33.5437C39.6864 33.5947 39.6933 33.6509 39.6841 33.7057C39.675 33.7604 39.6502 33.8114 39.6128 33.8524L36.8322 36.9398C36.7788 36.9976 36.7143 37.0441 36.6426 37.0764C36.5708 37.1086 36.4933 37.1261 36.4147 37.1277H23.2882C23.2327 37.1269 23.1786 37.1101 23.1324 37.0793C23.0862 37.0485 23.0499 37.005 23.0279 36.9541C23.0058 36.9032 22.999 36.8469 23.0081 36.7922C23.0173 36.7374 23.042 36.6865 23.0794 36.6455L25.8684 33.558ZM39.6254 30.9987C39.6628 31.0397 39.6875 31.0906 39.6966 31.1454C39.7058 31.2001 39.6989 31.2564 39.6769 31.3073C39.6548 31.3583 39.6185 31.4017 39.5723 31.4325C39.5261 31.4633 39.4721 31.4801 39.4165 31.4809L26.2943 31.4914C26.2156 31.4897 26.1381 31.4723 26.0663 31.44C25.9946 31.4077 25.9301 31.3613 25.8768 31.3035L23.0753 28.2264C23.0379 28.1854 23.0131 28.1345 23.0039 28.0797C22.9948 28.025 23.0017 27.9688 23.0237 27.9178C23.0458 27.8669 23.0821 27.8234 23.1282 27.7926C23.1744 27.7618 23.2285 27.745 23.284 27.7442L36.4063 27.7338C36.485 27.7354 36.5625 27.7528 36.6342 27.7851C36.706 27.8174 36.7705 27.8639 36.8238 27.9217L39.6254 30.9987ZM25.8684 22.2853C25.9218 22.2275 25.9863 22.1811 26.058 22.1488C26.1297 22.1165 26.2073 22.099 26.2859 22.0974L39.4124 22.1078C39.4678 22.1086 39.522 22.1254 39.5682 22.1562C39.6144 22.187 39.6507 22.2305 39.6726 22.2815C39.6947 22.3324 39.7016 22.3886 39.6925 22.4434C39.6833 22.4981 39.6585 22.5491 39.6211 22.5901L36.8322 25.6671C36.7788 25.7249 36.7143 25.7714 36.6426 25.8036C36.5708 25.8359 36.4933 25.8534 36.4147 25.855H23.2882C23.2327 25.8542 23.1786 25.8374 23.1324 25.8066C23.0862 25.7758 23.0499 25.7323 23.0279 25.6814C23.0058 25.6304 22.999 25.5742 23.0081 25.5195C23.0173 25.4647 23.042 25.4138 23.0794 25.3728L25.8684 22.2853Z",
    fill: "url(#paint0_linear_332_17201)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_17201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.5631 28.1095H72.5241V25.1035H83.9033V22.0974H72.5033C71.7116 22.0974 70.9522 22.4119 70.3923 22.9718C69.8326 23.5316 69.5181 24.2909 69.5181 25.0826V28.1304C69.5181 28.9221 69.8326 29.6814 70.3923 30.2413C70.9522 30.8011 71.7116 31.1156 72.5033 31.1156H81.5423V34.1217H69.733V37.1277H81.5631C82.3549 37.1277 83.1142 36.8132 83.6739 36.2534C84.2338 35.6935 84.5484 34.9342 84.5484 34.1425V31.0947C84.5484 30.303 84.2338 29.5437 83.6739 28.9839C83.1142 28.424 82.3549 28.1095 81.5631 28.1095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0673 22.0974H89.9949C89.6029 22.0974 89.2149 22.1746 88.8528 22.3247C88.4908 22.4747 88.1618 22.6947 87.8847 22.9719C87.6078 23.2491 87.3881 23.5782 87.2383 23.9404C87.0884 24.3025 87.0116 24.6907 87.0117 25.0826V34.1425C87.0116 34.5345 87.0884 34.9226 87.2383 35.2847C87.3881 35.6469 87.6078 35.976 87.8847 36.2532C88.1618 36.5305 88.4908 36.7504 88.8528 36.9004C89.2149 37.0505 89.6029 37.1277 89.9949 37.1277H99.0673C99.859 37.1277 100.618 36.8132 101.178 36.2534C101.738 35.6935 102.053 34.9342 102.053 34.1425V25.0826C102.053 24.2909 101.738 23.5316 101.178 22.9718C100.618 22.4119 99.859 22.0974 99.0673 22.0974ZM99.0465 34.1217H90.0283V25.1035H99.0465V34.1217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.818 22.0974H121.972C121.18 22.0974 120.42 22.4119 119.861 22.9718C119.301 23.5316 118.986 24.2909 118.986 25.0826V37.1277H121.992V32.1886H130.798V37.1277H133.804V25.0826C133.804 24.6905 133.727 24.3022 133.577 23.9399C133.427 23.5776 133.207 23.2484 132.93 22.9711C132.653 22.6939 132.324 22.474 131.961 22.3241C131.599 22.1742 131.211 22.0971 130.818 22.0974ZM130.798 29.1825H121.992V25.1035H130.798V29.1825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.015 22.0974H157.17C156.777 22.0966 156.388 22.1732 156.025 22.3229C155.662 22.4725 155.333 22.6923 155.055 22.9695C154.777 23.2468 154.556 23.5762 154.406 23.9388C154.256 24.3014 154.178 24.6901 154.178 25.0826V37.1277H157.184V32.1886H165.994V37.1277H169V25.0826C169 24.2909 168.685 23.5316 168.126 22.9718C167.566 22.4119 166.806 22.0974 166.015 22.0974ZM165.994 29.1825H157.191V25.1035H165.994V29.1825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.502 34.1217H147.3L142.991 23.3499C142.844 22.9804 142.589 22.6635 142.26 22.4402C141.93 22.2169 141.542 22.0975 141.144 22.0974H138.468C137.94 22.0974 137.434 22.307 137.061 22.6801C136.688 23.0532 136.478 23.5592 136.478 24.0868V37.1277H139.484V25.1035H140.687L144.993 35.8752C145.14 36.2448 145.394 36.5618 145.723 36.7851C146.052 37.0084 146.441 37.1278 146.838 37.1277H149.515C150.042 37.1277 150.548 36.9181 150.922 36.545C151.295 36.1719 151.504 35.6659 151.504 35.1383V22.0974H148.498L148.502 34.1217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.722 22.0974H104.716V34.1425C104.716 34.9342 105.03 35.6935 105.59 36.2534C106.15 36.8132 106.909 37.1277 107.701 37.1277H116.74V34.1217H107.722V22.0974Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_332_17201",
    x: -81.5485,
    y: -81.451,
    width: 354.097,
    height: 222.097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 40.7742
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_332_17201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_332_17201",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_332_17201",
    x1: 23.5074,
    y1: 37.4555,
    x2: 39.1932,
    y2: 21.7697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8A53F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6377D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#24B0A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00D18C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D18C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_17201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 15.0303,
    fill: "white",
    transform: "translate(45 22.0974)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.d4d9e0be8154e1d7ffc0de4286d6ffed.svg";
export { ForwardRef as ReactComponent };